import { api } from "../api.slice";
import { apiEndpoints } from "@/utils/api-endpoints";
import {ICartItem} from "@/types/general";

const cartApi = api.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getCart: builder.query<Array<ICartItem>, void>({
            query: () => ({
                url: apiEndpoints.Cart.GetCart.url,
                method: apiEndpoints.Cart.GetCart.method,
            }),
            providesTags: ["Cart"],
        }),
        getGiftCode: builder.mutation<number, { GiftCode: string }>({
            query: ({ GiftCode }) => ({
                url: `${apiEndpoints.Cart.GetGiftAmount.url}?giftCode=${encodeURIComponent(GiftCode)}`,
                method: "GET",
            }),
        }),


        addToCart: builder.mutation<boolean, { ProductId: string; Count: number }>({
            query: (body) => ({
                url: apiEndpoints.Cart.Add.url,
                method: apiEndpoints.Cart.Add.method,
                body,
            }),
            invalidatesTags: ["Cart", "CartCount"],
        }),

        removeFromCart: builder.mutation<boolean, { ProductId: string }>({
            query: (body) => ({
                url: apiEndpoints.Cart.Remove.url,
                method: apiEndpoints.Cart.Remove.method,
                body,
            }),
            invalidatesTags: ["Cart", "CartCount"],
        }),

        confirmCart: builder.mutation<
            number,
            {
                GiftCode?: string;
                CartType: number;
                SendPriority: number;
                SettleDays: number;
                Comment: string;
            }
        >({
            query: (body) => ({
                url: apiEndpoints.Cart.Confirm.url,
                method: apiEndpoints.Cart.Confirm.method,
                body,
            }),
            invalidatesTags: ["Cart", "CartCount", "Order"],
        }),

    }),
});

export const {
    useGetCartQuery,
    useGetGiftCodeMutation,
    useAddToCartMutation,
    useRemoveFromCartMutation,
    useConfirmCartMutation,
} = cartApi;
